import { Component, ReactNode } from "react";

export const KIOSK_CRASH_RELOAD_MS = 60_000;

interface KioskErrorBoundaryState {
  crashed: boolean;
}

/** Last line of defence for an unattended kiosk: if the player itself
 *  crashes, go black (never a React error page in the waiting room) and
 *  reload the page a minute later, which rebuilds everything from scratch. */
export class KioskErrorBoundary extends Component<{ children: ReactNode }, KioskErrorBoundaryState> {
  state: KioskErrorBoundaryState = { crashed: false };
  private reloadTimer: ReturnType<typeof setTimeout> | null = null;

  static getDerivedStateFromError(): KioskErrorBoundaryState {
    return { crashed: true };
  }

  componentDidCatch() {
    if (this.reloadTimer) return;
    this.reloadTimer = setTimeout(() => window.location.reload(), KIOSK_CRASH_RELOAD_MS);
  }

  componentWillUnmount() {
    if (this.reloadTimer) clearTimeout(this.reloadTimer);
  }

  render() {
    if (this.state.crashed) {
      return <div data-testid="kiosk-crashed" className="absolute inset-0 bg-black" />;
    }
    return this.props.children;
  }
}
